import React from 'react';
import { List, Datagrid, Filter, TextField, TextInput, BooleanField } from 'react-admin';

const EventLocationFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const EventLocationList = props => (
  <List filters={<EventLocationFilter />} {...props} exporter={false}>
    <Datagrid rowClick="edit" >
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="detail" />
      <BooleanField source="enabled" />
    </Datagrid>
</List>
);

export default EventLocationList
